import { useEffect, useState } from "react";
import { useShowMore } from "../../../../hooks/useShowMore";
import {
    Container,
    BikesSection,
    BikeImage,
    BikeContent,
    Title,
    Description,
    Header,
    ButtonDiv,
    ShowMoreButton,
    PriceTag,
} from "./styled";
import { bikeList } from "./bikesData";
import { StaggeredContainer, StaggeredItem } from "../../../animations/staggeredFadeIn";
import { useTranslation } from "react-i18next";

const useIsMobile = (maxWidth = 767) => {
    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" && window.innerWidth <= maxWidth
    );

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= maxWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [maxWidth]);

    return isMobile;
};

const BikeRental = () => {
    const { t } = useTranslation("bikesDescription");
    const isMobile = useIsMobile();
    const { showAll, handleToggle, buttonRef } = useShowMore();

    const contentToShow = showAll
        ? bikeList
        : isMobile
            ? bikeList.slice(0, 1)
            : bikeList.slice(0, 3);

    return (
        <Container>
            <StaggeredContainer>
                <StaggeredItem>
                    <Header>{t("header")}</Header>
                </StaggeredItem>

                <StaggeredItem>
                    {contentToShow.map((bike) => (
                        <BikesSection key={bike.id}>
                            <BikeImage
                                src={bike.image}
                                alt={t(`items.${bike.id}.title`)}
                            />
                            <BikeContent>
                                <Title>{t(`items.${bike.id}.title`)}</Title>
                                <Description>{t(`items.${bike.id}.description`)}</Description>
                                <PriceTag>{t(`items.${bike.id}.price`)}</PriceTag>
                            </BikeContent>
                        </BikesSection>
                    ))}
                </StaggeredItem>

                {bikeList.length > 3 && (
                    <ButtonDiv>
                        <ShowMoreButton onClick={handleToggle} ref={buttonRef}>
                            {showAll ? t("showLess") : t("showMore")}
                        </ShowMoreButton>
                    </ButtonDiv>
                )}
            </StaggeredContainer>
        </Container>
    );
};

export default BikeRental;